module.exports = kolibriGlobal.coreVue.components.KSelect;